module.exports = __webpack_public_path__ + "img/karachunskiy.2aeec9f5.jpg";